import moment from "moment/moment";
import CircularBar from "../../../../components/chart-bars/CircularBar";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useState } from "react";
import useScoreScale from "../../../../utils/hooks/useScoreScale";

const ARDetails = ({
  storeIdData,
  handleViewAi,
  value,
  primaryColor,
  colorScale,
}) => {
  const {
    text: scoreText,
    color,
    scoreLegend,
  } = useScoreScale(value, colorScale);
  const [isAuditDetailsOpen, setIsAuditDetailsOpen] = useState(true);

  return (
    <div className="card">
      <div
        className="card-header"
        onClick={() => setIsAuditDetailsOpen((prev) => !prev)}
        style={{
          backgroundColor: primaryColor || undefined,
          color: primaryColor ? "#fff" : undefined,
        }}
      >
        <p>Audit Details</p>
        {!isAuditDetailsOpen ? <UpOutlined /> : <DownOutlined />}
      </div>

      <div className={`card-content ${isAuditDetailsOpen ? "open" : "closed"}`}>
        <div className="hero-left-main col-md-6">
          <div className="overall d-flex align-items-center gap-2 mt-2">
            <p className="my-2">Overall Score</p>
            <div
              className="score-perR df"
              style={{
                backgroundColor: color,
              }}
            >
              <p className="my-2">{value}%</p>
            </div>
          </div>

          <div className="left-details d-flex">
            <table>
              <tbody>
                <tr>
                  <td className="leftTexts">
                    <strong>Client</strong>
                  </td>
                  <td className="rightTexts">
                    {storeIdData?.audit?.store?.client?.name || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="leftTexts">
                    <strong>Store Code</strong>
                  </td>
                  <td className="rightTexts">
                    {storeIdData?.audit?.store?.code || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="leftTexts">
                    <strong>Store Name</strong>
                  </td>

                  <td className="rightTexts">
                    <div style={{ lineHeight: "2rem" }}>
                      {storeIdData?.audit?.store?.name}
                    </div>
                  </td>
                </tr>
                <tr></tr>
                <tr>
                  <td className="leftTextsSA">
                    <strong>Store Address</strong>
                  </td>
                  <td className="rightTexts">
                    <div>{storeIdData?.audit?.store?.address}</div>
                  </td>
                </tr>
                <tr>
                  <td className="leftTexts">
                    <strong>Audit Date</strong>
                  </td>
                  <td className="rightTexts">
                    {storeIdData?.audit_date
                      ? moment(storeIdData.audit_date).format("Do MMM YYYY")
                      : "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            onClick={handleViewAi}
            className="view-Ai mt-5 d-flex gap-1 justify-content-center align-items-center no-print p-0"
            style={{ marginTop: "100px" }}
          >
            <div className="iconStar my-2">
              <i className="bi bi-stars"></i>
            </div>
            <p className="my-2">View AI Insights</p>
          </div>
        </div>

        <div className="hero-right col-md-4 my-2 meter d-flex flex-column align-items-center justify-content-center">
          <p className="overallPara m-2">Overall Store Score</p>
          <CircularBar value={value ?? 0} color={color} />
          <div className="store-score d-flex justify-content-center align-items-center flex-column">
            <p className="scorePara">
              Your Store Score Is &nbsp;
              <span style={{ color: color }}>{scoreText}</span>
            </p>
            <div className="stats">
              <p className="m-0">What this statistics mean?</p>
            </div>
            <div className="grades-div d-flex flex-wrap gap-2 mt-3">
              {scoreLegend.map((range) => (
                <div
                  key={range.key}
                  style={{
                    width: range.key === "excellent" ? "55px" : undefined,
                  }}
                  className="stats-mean d-flex flex-column align-items-center justify-content-center"
                >
                  <p className="grade m-1">{range.text}</p>

                  <p className="percent m-0">
                    {range.min}% to{" "}
                    {range.max === 100 ? "above" : `${range.max}%`}
                  </p>

                  <div
                    className="mt-1 stats-div"
                    style={{
                      width: "41px",
                      height: "8px",
                      borderRadius: "10px",
                      backgroundColor: range.bgColor,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ARDetails;
